import { c as _c } from "react/compiler-runtime";
import { CustomerAttentToolItem } from '@/types/amplience';
import AmplienceLink from '../Common/AmplienceLink';
import DynamicIcon from '../Common/DynamicIcon';
type CustomerAttentionItemProps = {
  item: CustomerAttentToolItem;
};
export const CustomerAttentionItem = props => {
  const $ = _c(3);
  const {
    item
  } = props;
  let t0;
  if ($[0] !== item.cta || $[1] !== item.title) {
    t0 = item.cta && item.cta.length && item.cta[0] ? <AmplienceLink className="flex h-full w-full items-center justify-center text-center" link={item.cta[0]}><span>{item.title}</span><DynamicIcon className="ml-1 inline-block size-4" icon="chevrons" aria-hidden="true" /></AmplienceLink> : <p>{item.title}</p>;
    $[0] = item.cta;
    $[1] = item.title;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};